





















import { Vue, Component } from 'vue-property-decorator';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import EventBus, { Event } from '@/event.bus'
import BusinessUnit from '../../domain/business-unit/entity/business-unit.entity';

@Component
export default class Menu extends Vue {
  showMenu: boolean = false;

  selectedBusinessUnit = new BusinessUnit({})

  created() {
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.selectedBusinessUnit.id !== businessUnit.id) {
        this.selectedBusinessUnit = businessUnit
      }
    })
  }

  get businessUnits() {
    return UserBusinessUnitService.businessUnits
  }

  setSelected() {
    UserBusinessUnitService.setSelectedBusinessUnit(this.selectedBusinessUnit)
  }
}
